import React from 'react';
// import * as _ from 'lodash';
import { Menu, Dropdown } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { arrowDownSvg } from '../../HelperMethods/constants';
import styles from './CustomMenu.module.css';

const findSelectedOptions = (selected, option, fieldsDict, allOptionsfromDropdown) => {
  const lengthOfListWithoutallFieldsandUnassigned = fieldsDict ? Object.keys(fieldsDict).length : 0;
  const notassignedtofieldinDropdownoptionflag =
    allOptionsfromDropdown.filter((item) => item.name === 'notassignedtofields').length > 0;
  if (Array.isArray(selected)) {
    if (option.name === 'all-fields') {
      if (selected.findIndex((val) => val === 'all-fields') !== -1) {
        return true;
      }

      const selectedFieldwithoutAllField = selected.filter((val) => val !== 'all-fields') || [];

      if (notassignedtofieldinDropdownoptionflag) {
        if (selectedFieldwithoutAllField.length === lengthOfListWithoutallFieldsandUnassigned + 1) {
          return true;
        }
      } else if (selectedFieldwithoutAllField.length === lengthOfListWithoutallFieldsandUnassigned) {
        return true;
      }
      return false;
      // eslint-disable-next-line no-else-return
    } else {
      return selected.find((val) => val === option.id);
    }
  }
  return selected.id === option.id;
};

function MenuComponent(props) {
  const { selected, options = [], clickHandler, fieldsDict, label, size = 'sm' } = props;
  return (
    <Menu className={size === 'lg' ? styles.customMenuLarge : styles.customMenu}>
      <Dropdown
        item
        text={label}
        icon={
          <img
            src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(arrowDownSvg('#a2a2a0'))}`}
            style={{ paddingLeft: '22px' }}
          />
        }
      >
        <Dropdown.Menu
          style={{
            maxWidth: '200px',
            minWidth: '150px',
          }}
        >
          {options.map((option) => {
            return (
              <Dropdown.Item
                onClick={() => {
                  clickHandler(option);
                }}
                key={option.id}
                style={{
                  display: 'flex',
                  width: '150px',
                  justifyContent: 'space-between',
                }}
              >
                <>
                  <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {option.name}
                  </div>
                  <div>
                    <i
                      className="fa fa-check"
                      style={{
                        color: '#00CFBB',
                        float: 'right',
                        display: findSelectedOptions(selected, option, fieldsDict, options) ? 'block' : 'none',
                      }}
                    />
                  </div>
                </>
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    </Menu>
  );
}

MenuComponent.propTypes = {
  selected: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.shape({ id: PropTypes.string })]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })
  ),
  fieldsDict: PropTypes.object,

  clickHandler: PropTypes.func,
  label: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'lg']),
};

export default MenuComponent;
